import { Injectable } from "@angular/core";
import { Params } from "@angular/router";

@Injectable()
export class SessionStorageService
{

  private static NOME_TRAMITE: string = 'tramite';
  private static NOME_CHAVE_ACESSO: string = 'chaveAcesso';
  private static NOME_ASSINANTE: string = 'assinante';
  private static NOME_REDIRECIONAMENTO_GOV_BR: string = 'redirecionamentoGovBr';
  private static NOME_ACESSO_EXTERNO: string = 'acessoExterno';


  public getTramite(): string | null{
    return sessionStorage.getItem(SessionStorageService.NOME_TRAMITE);
  }
  public setTramite(idTramite)
  {
    sessionStorage.setItem(SessionStorageService.NOME_TRAMITE, idTramite.toString());
  }

  public getChaveAcesso(): string | null{
      return sessionStorage.getItem(SessionStorageService.NOME_CHAVE_ACESSO);
    }

    public getAssinante(): string | null{
      return sessionStorage.getItem(SessionStorageService.NOME_ASSINANTE);
    }
    public getRedirecionamentoGovBr():  string | null{
      return sessionStorage.getItem(SessionStorageService.NOME_REDIRECIONAMENTO_GOV_BR);
    }
    public removerRedirecionamentoGovBr() {
      sessionStorage.removeItem(SessionStorageService.NOME_REDIRECIONAMENTO_GOV_BR);
    }

    public getTokenAcessoExterno(): string | null{
      return sessionStorage.getItem(SessionStorageService.NOME_ACESSO_EXTERNO);
    }
    public setTokenAcessoExterno(token: string | null){
      if (token == null)
      {
        this.removeTokenAcessoExterno();
        return;
      }
      sessionStorage.setItem(SessionStorageService.NOME_ACESSO_EXTERNO, token);
    }
    public removeTokenAcessoExterno(){
      sessionStorage.removeItem(SessionStorageService.NOME_ACESSO_EXTERNO);
    }

    public limparDadosSessaoParaGovBr() {
        sessionStorage.removeItem(SessionStorageService.NOME_CHAVE_ACESSO);
        sessionStorage.removeItem(SessionStorageService.NOME_TRAMITE);
        sessionStorage.removeItem(SessionStorageService.NOME_ASSINANTE);
        sessionStorage.removeItem(SessionStorageService.NOME_REDIRECIONAMENTO_GOV_BR);
    }

    public salvarDadosSessaoParaGovBr(params: Params) {
      sessionStorage.setItem(SessionStorageService.NOME_CHAVE_ACESSO, params.chaveAcesso);
      sessionStorage.setItem(SessionStorageService.NOME_ASSINANTE, params.idAssinante);
      sessionStorage.setItem(SessionStorageService.NOME_REDIRECIONAMENTO_GOV_BR, '1');
  }
}
